import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Flex,
  Image,
  Input,
  Modal,
  PaginationProps,
  Select,
  Table,
  TableColumnsType,
  Tabs,
} from "antd";
import { ArrowSquareDown, Clock, Crown, SearchZoomIn1 } from "iconsax-react";
import "./DasTotalMatchModal.scss";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
// import tableData from '../playersTableData.json'
import { mixPostV1 } from "../../../services/mixin";
import { IMAGE_URL } from "../../../env";

interface Props {
  isShow?: boolean;
  players?: Array<any>;
  typeParam?: any;
  selectedDate?: any;
  onPopupClose?: () => void;
  onAddPlayer?: (player: any) => void;
  dataView?: any;
}
interface DataTypeReport {
  machine_number: string;
  img_machine: string;
  in_number: number;
  out_number: number;
}
const closeIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.86312 3.86363C4.03189 3.6949 4.26077 3.60012 4.49942 3.60012C4.73806 3.60012 4.96694 3.6949 5.13572 3.86363L8.99942 7.72733L12.8631 3.86363C12.9461 3.77767 13.0455 3.7091 13.1553 3.66194C13.2651 3.61477 13.3832 3.58994 13.5027 3.5889C13.6222 3.58786 13.7407 3.61063 13.8513 3.65589C13.9619 3.70114 14.0624 3.76797 14.1469 3.85247C14.2314 3.93697 14.2982 4.03746 14.3435 4.14807C14.3887 4.25867 14.4115 4.37719 14.4104 4.49669C14.4094 4.61619 14.3846 4.73429 14.3374 4.84409C14.2902 4.95389 14.2217 5.0532 14.1357 5.13623L10.272 8.99993L14.1357 12.8636C14.2997 13.0334 14.3904 13.2607 14.3883 13.4967C14.3863 13.7327 14.2916 13.9584 14.1248 14.1253C13.9579 14.2921 13.7322 14.3868 13.4962 14.3888C13.2602 14.3909 13.0329 14.3002 12.8631 14.1362L8.99942 10.2725L5.13572 14.1362C4.96598 14.3002 4.73863 14.3909 4.50266 14.3888C4.26668 14.3868 4.04095 14.2921 3.87408 14.1253C3.70721 13.9584 3.61256 13.7327 3.61051 13.4967C3.60846 13.2607 3.69918 13.0334 3.86312 12.8636L7.72682 8.99993L3.86312 5.13623C3.69439 4.96745 3.59961 4.73857 3.59961 4.49993C3.59961 4.26128 3.69439 4.0324 3.86312 3.86363Z"
      fill="#6B7280"
    />{" "}
  </svg>
);

interface DataType {
  key: React.Key;
  appId?: string;
  customerName?: string;
  customerPhone?: string;
  customerFace?: string;
  customerTimer?: string;
  shift?: string;
}

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const AddPlayerModal: React.FC<Props> = (props) => {
  const {
    isShow = false,
    players,
    onPopupClose,
    onAddPlayer,
    typeParam = 1,
    selectedDate,
    dataView,
  } = props;
  const [open, setOpen] = useState(isShow);
  const [selectedPlayers, setSelectedPlayers] = useState([] as any);
  const [currentTab, setCurrentTab] = useState("1");
  const tabs = [
    {
      key: "1",
      label: (
        <div className="title-tab-setting">
          <div className="text t-fz-16">Begin</div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="title-tab-setting">
          <div className="text t-fz-16">End</div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div className="title-tab-setting">
          <div className="text t-fz-16">Profit</div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    setOpen(isShow);

    if (isShow) {
      const selected: any = [];
      const selectedId: any = [];
      // eslint-disable-next-line array-callback-return
      players?.map((item: any) => {
        selected.push(item);
        selectedId.push(item.id);
      });
      setSelectedPlayers(selected);
      setSelectedRowKeys(selectedId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow]);

  const onClose = () => {
    setOpen(false);
    if (onPopupClose) {
      onPopupClose();
    }
  };
  // const columns: TableColumnsType<DataType> = [
  //   {
  //     title: "Machine",
  //     dataIndex: "machine_number",
  //     key: "machine_number",
  //   },
  //   {
  //     title: "",
  //     dataIndex: "img_machine",
  //     key: "img_machine",
  //     render: (text, record: any, index) => (
  //       <Flex align="center" gap={12}>
  //         <Image
  //           height={40}
  //           width={40}
  //           src={record.img_machine}
  //           alt={record.machine_number}
  //           preview={{
  //             src: `${record.img_machine}`,
  //           }}
  //           style={{
  //             borderRadius: "50%",
  //             overflow: "hidden",
  //             objectFit: "cover",
  //           }}
  //         />
  //         {/* <span>{ text }</span> */}
  //       </Flex>
  //     ),
  //   },
  //   {
  //     title: "In ($)",
  //     dataIndex: "in_number",
  //     key: "in_number",
  //   },
  //   {
  //     title: "Out ($)",
  //     dataIndex: "out_number",
  //     key: "out_number",
  //   },
  // ];

  const columns: TableColumnsType<DataTypeReport> = useMemo(() => {
    const baseColumns: TableColumnsType<DataTypeReport> = [
      {
        title: "Machine",
        dataIndex: "machine_number",
        key: "machine_number",
      },
    ];

    // Nếu status khác 2, thêm cột hình ảnh
    if (currentTab !== "3") {
      baseColumns.push({
        title: "",
        dataIndex: "img_machine",
        key: "img_machine",
        render: (text, record: any, index) => (
          <Flex align="center" gap={12}>
            <Image
              height={40}
              width={40}
              src={record.img_machine}
              alt={record.machine_number}
              preview={{ src: record.img_machine }}
              style={{
                borderRadius: "50%",
                overflow: "hidden",
                objectFit: "cover",
              }}
            />
          </Flex>
        ),
      });
    }

    // Cột in và out luôn có
    baseColumns.push(
      {
        title: "In ($)",
        dataIndex: "in_number",
        key: "in_number",
      },
      {
        title: "Out ($)",
        dataIndex: "out_number",
        key: "out_number",
      }
    );

    // Nếu status là 2, thêm cột Profit
    if (currentTab === "3") {
      baseColumns.push({
        title: "Profit ($)",
        key: "profit",
        render: (_, record) => {
          const profit =
            Number(record?.in_number ?? 0) - Number(record?.out_number ?? 0);
          return (
            <span style={{ color: profit < 0 ? "#FD8181" : "#55c790" }}>
              {profit.toLocaleString()}
            </span>
          );
        },
      });
    }

    return baseColumns;
  }, [currentTab]);

  // TABLE ROW SELECTION
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    selectedRows: any
  ) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedPlayers(selectedRows);
  };
  const rowSelection = {
    fixed: true,
    selectedRowKeys,
    columnWidth: 68,
    onChange: onSelectChange,
  };
  // END TABLE ROW SELECTION

  // ADD PLAYERS
  const [loading, setLoading] = useState(false);
  const addPlayer = () => {
    setLoading(true);
    const players: any = [];
    selectedPlayers.map((item: any) =>
      players.push({
        ...item,
        id: item.customer_id,
        name: item.customer_name,
        avatar: item.avatar || "/images/avatar/avatar1-40x40.png",
      })
    );

    setTimeout(() => {
      // setSelectedRowKeys([])
      setLoading(false);
      if (onAddPlayer) {
        onAddPlayer(players);
      }
    }, 1000);
  };
  // END ADD PLAYERS

  // GET PLAYERS
  const [items, setItems] = useState({
    list1: [],
    list2: [],
  } as any);
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchCustomerName?: string;
    searchCustomerPhone?: string;
    levels?: number | string;
    searchShift?: number | string;
  }>({} as any);

  const formatDate = (date: any) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [total, setTotal] = useState({
    end_in: 0,
    end_out: 0,
    begin_in: 0,
    begin_out: 0,
  });
  const getItems = async () => {
    setTableLoading(true);

    try {
      const apiParams = {
        report_id: dataView?.report_id,
      } as any;
      const res = await mixPostV1(
        "/api/webAdmin/gDetailReportIncome.php",
        apiParams
      );

      if (res.status === 1) {
        const temp = {
          end_in: 0,
          end_out: 0,
          begin_in: 0,
          begin_out: 0,
        } as any;
        setTableLoading(false);
        const beginData: any = [];
        const endData: any = [];
        const profitData: any = res.data.profit;
        res.data.beginData.map((item: any, index: any) => {
          beginData.push({
            ...item,
            key: `${item.rd_id}-${item.report_id}-${item.machine_id}`,
          });
          temp.begin_in += item.in_number;
          temp.begin_out += item.out_number;
          return true;
        });
        res.data.endData.map((item: any, index: any) => {
          endData.push({
            ...item,
            key: `${item.rd_id}-${item.report_id}-${item.machine_id}`,
          });
          temp.end_in += item.in_number;
          temp.end_out += item.out_number;
          return true;
        });

        setTotal(temp);
        setItems({
          ...res.data,
          list1: beginData,
          list2: endData,
          list3: profitData,
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataView]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET PLAYERS

  // SEARCH
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const [searchType, setSearchType] = useState("phone-number");
  const onSearch = (query: string) => {
    if (searchType === "phone-number") {
      setParams({
        ...params,
        page_number: 1,
        searchCustomerPhone: query,
        searchCustomerName: "",
      });
    }
    if (searchType === "name") {
      setParams({
        ...params,
        page_number: 1,
        searchCustomerPhone: "",
        searchCustomerName: query,
      });
    }
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };
  // END SEARCH

  // SHIFT CHANGE
  const [shiftTimeout, setShiftTimeout] = useState<any>(null);
  const onShiftFilter = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      searchShift: query,
    });
  };
  const onShiftEnter = (e: any) => {
    onShiftFilter(e.target.value);
  };
  const onShiftChange = (e: any) => {
    clearTimeout(shiftTimeout);
    const timeout = setTimeout(() => {
      onShiftFilter(e.target.value);
    }, 250);
    setShiftTimeout(timeout);
  };
  // END SHIFT CHANGE

  return (
    <Modal
      centered
      open={open}
      closeIcon={closeIcon}
      footer={null}
      className="rs-modal das-total-match-modal"
      rootClassName="rs-modal-root"
      onCancel={onClose}
    >
      <div className="title-mix">Detail Machine Income</div>
      <div className="info-detail">
        <div className="item">
          <div className="lb">Time</div>
          <div className="val">{items.date_report}</div>
        </div>
        <div className="item">
          <div className="lb">Shift</div>
          <div className="val">{items.shift}</div>
        </div>
        <div className="item">
          <div className="lb">Staff</div>
          <div className="val">{items.staff_name}</div>
        </div>
        <div className="list-tt">
          <div className="item">
            <div className="lb">Begin In($)</div>
            <div className="val">{total.begin_in}</div>
          </div>
          <div className="item">
            <div className="lb">Begin Out($)</div>
            <div className="val">{total.begin_out}</div>
          </div>
        </div>
        <div className="list-tt">
          <div className="item">
            <div className="lb">End In($)</div>
            <div className="val">{total.end_in}</div>
          </div>

          <div className="item">
            <div className="lb">End Out($)</div>
            <div className="val">{total.end_out}</div>
          </div>
        </div>
      </div>
      <Tabs
        activeKey={currentTab}
        items={tabs}
        className="rs-tabs rs-tabs--no-tab-content"
        onChange={(e) => {
          setCurrentTab(e);
        }}
      />
      <Table
        columns={columns}
        dataSource={
          currentTab === "1"
            ? items.list1
            : currentTab === "2"
            ? items.list2
            : items.list3
        }
        className="rs-table table-text-nowrap match-height"
        loading={tableLoading}
        scroll={{
          x: true,
        }}
        pagination={false}
      />
    </Modal>
  );
};

export default AddPlayerModal;
